export default "__VITE_ASSET__f4e70afc__"